module.exports = __webpack_public_path__ + "media/images/android-chrome-48x48-0f99a8cc763941996a2aa61ac715e3d1.png";